import { render, staticRenderFns } from "./JoinPassword.vue?vue&type=template&id=7daf15b4&scoped=true&"
import script from "./JoinPassword.vue?vue&type=script&lang=js&"
export * from "./JoinPassword.vue?vue&type=script&lang=js&"
import style0 from "./JoinPassword.vue?vue&type=style&index=0&id=7daf15b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf15b4",
  null
  
)

export default component.exports